import React from "react";
import { VstLoader } from "vstui";
import MarkdownContainer from "../notebook/markdown-container";
import MarkdownButtonsList from "../notebook/markdown-buttons-list";
import { contains } from "../../../utils/dom-utils/";

class HighlighterNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
    this.startEditing = this.props.setEditing.bind(this, true);
    this.stopEditing = this.props.setEditing.bind(this, false);
    this.onMarkdownChange = this.onMarkdownChange.bind(this);
    this.mdContainer = null;
    this.toggleDropdowns = () =>
      this.setState(dropdownOpen => ({ dropdownOpen }));
  }

  onMarkdownChange(text, start, end) {
    this.props.onNoteTextChange({ markdown: text });
    if (this.textArea) {
      this.textArea.selectionStart = start;
      this.textArea.selectionEnd = end;
      this.textArea.focus();
    }
  }

  onBlur = e => {
    const inside =
      e.relatedTarget && contains(this.mdContainer, e.relatedTarget);

    if (!inside) {
      this.stopEditing();
    }
  };

  render() {
    const { noteText, isEditing, savingNote, highlight } = this.props;
    const shared = highlight && highlight.shared;
    if (shared && noteText.length === 0) {
      return <span />;
    }

    if (savingNote) {
      return (
        <div id="highlighter-notes">
          <div className="note-preview">
            <VstLoader />
          </div>
        </div>
      );
    }
    if (noteText && !isEditing) {
      return (
        <div id="highlighter-notes">
          <div
            className="note-preview"
            style={shared ? {} : { cursor: "pointer" }}
          >
            <MarkdownContainer
              onClick={this.startEditing}
              markdown={this.props.noteText}
            />
            {shared && (
              <div
                className="preview-background"
                style={{ backgroundColor: highlight.vstColor }}
              />
            )}
          </div>
        </div>
      );
    }

    return (
      <div id="highlighter-notes">
        <div
          className="note-edit-container"
          ref={mdContainer => (this.mdContainer = mdContainer)}
          onBlur={this.onBlur}
        >
          {isEditing && (
            <MarkdownButtonsList
              ref={mdList => (this.mdList = mdList)}
              className="markdown-actions"
              contextMenu
              selectionStart={this.textArea && this.textArea.selectionStart}
              selectionEnd={this.textArea && this.textArea.selectionEnd}
              note={noteText}
              textArea={this.textArea}
              saving={this.props.savingNote}
              onChange={this.onMarkdownChange}
              dropdownOpen={this.state.dropdownOpen}
              toggleDropdown={this.toggleDropdowns}
            />
          )}
          <textarea
            ref={textArea => (this.textArea = textArea)}
            id="edit-note-text-area"
            data-testid="edit-note-text-area"
            placeholder={i18n.t("reader.notebook.add-note")}
            className={`note-text-area ${isEditing ? "editing" : ""}`}
            value={noteText}
            onClick={this.startEditing}
            onFocus={this.startEditing}
            onChange={this.props.onNoteTextChange}
          />
        </div>
      </div>
    );
  }
}

export default HighlighterNotes;
